import { render, staticRenderFns } from "./editScoreScaleDeveloped.vue?vue&type=template&id=0bf8168e&scoped=true"
import script from "./editScoreScaleDeveloped.vue?vue&type=script&lang=js"
export * from "./editScoreScaleDeveloped.vue?vue&type=script&lang=js"
import style0 from "./editScoreScaleDeveloped.vue?vue&type=style&index=0&id=0bf8168e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8168e",
  null
  
)

export default component.exports